module.exports = __webpack_public_path__ + "img/egg_planes_sad.9c627e22.svg";